/**
 * TargetsBoundsCard - Shows min/max latitude/longitude bounds for a targets popup
 */
import React from 'react';
import { Card } from '@ais-ui/ui-core';
import { Messages } from '@ais-ui/locale-management';

export interface TargetsBoundsCardProps {
  bounds: {
    minLat: number;
    maxLat: number;
    minLon: number;
    maxLon: number;
  };
  total: number;
  messages: Messages;
}

export const TargetsBoundsCard: React.FC<TargetsBoundsCardProps> = ({
  bounds,
  total,
  messages,
}) => {
  return (
    <Card className="p-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <span className="text-sm text-muted-foreground">
            {messages.popupTargetsTotal}
          </span>
          <p className="text-lg font-medium">{total}</p>
        </div>
        <div>
          <span className="text-sm text-muted-foreground">
            {messages.popupTargetsMinLat}
          </span>
          <p className="text-lg font-medium">
            {bounds?.minLat != null ? Number(bounds.minLat).toFixed(4) : '-'}°
          </p>
        </div>
        <div>
          <span className="text-sm text-muted-foreground">
            {messages.popupTargetsMaxLat}
          </span>
          <p className="text-lg font-medium">
            {bounds?.maxLat != null ? Number(bounds.maxLat).toFixed(4) : '-'}°
          </p>
        </div>
        <div>
          <span className="text-sm text-muted-foreground">
            {messages.popupTargetsMinLon}
          </span>
          <p className="text-lg font-medium">
            {bounds?.minLon != null ? Number(bounds.minLon).toFixed(4) : '-'}°
          </p>
        </div>
      </div>
    </Card>
  );
};
